import React, { useEffect, useMemo } from "react";
import { renderAvatar, ensureAvatarCss } from "@/lib/avatar2d";
import { renderQueen } from "@/lib/lhQueen";

// One raider (a character from avatarConfig) in a pose: idle, walk, ready,
// taunt, cheer, sad... `flag` is a colour for a flag in their hand, and
// `mirror` turns them to face left.
export default function Avatar2D({ character, pose = "idle", flag = null, mirror = false, className = "" }) {
  useEffect(() => ensureAvatarCss(), []);
  const svg = useMemo(
    // A Letterheist queen ({ queen } look) has no poses.
    () => (!character ? "" : character.look?.queen ? renderQueen(character.look.queen) : renderAvatar(character.look, { pose, flag })),
    [character, pose, flag],
  );
  return (
    <div
      className={className}
      style={mirror ? { transform: "scaleX(-1)" } : undefined}
      data-testid="avatar2d"
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
}
